<template>
  <v-menu offset-y :rounded="true">
    <template #activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon color="var(--color-secondary)">mdi-menu</v-icon>
      </v-btn>
    </template>
    <v-list>
      <UpdateVesselPositionOption />
      <v-list-item
        v-for="option in options"
        :key="option.text"
        @click="option.action"
      >
        <v-list-item-icon>
          <v-icon color="primary">{{ option.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ option.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions } from "vuex";
import UpdateVesselPositionOption from "./UpdateVesselPositionOption.vue";
export default {
  name: "ComputationOptions",
  components: {
    UpdateVesselPositionOption,
  },
  data() {
    return {
      options: [
        {
          text: "Recompute",
          icon: "mdi-refresh",
          action: () => this.onRecomputePressed(),
        },
      ],
      dialog: false,
    };
  },
  methods: {
    ...mapActions("weatherRouting/voyageDetailsModule", [
      "pushVoyageRecalculation",
    ]),
    async onRecomputePressed() {
      await this.pushVoyageRecalculation({
        voyageId: this.$route.params.voyageId,
        updateVesselPosition: false,
      });
    },
    onPrimaryButtonPressed() {
      this.dialog = false;
    },
    onCancelButtonPressed() {
      this.dialog = false;
    },
  },
};
</script>


